









































































































import Vue from 'vue'
import { getSites } from '@/modules/site/site.service';
import { getGuestCategoriesForEventCategory,getGuestCategoriesForEvent } from '@/modules/event/guest-category.service';
import { getEventCategories, postEvent,patchEvent,postEventGuestCategoryRelations,deleteEventGuestCategoryRelations } from '@/modules/event/event.service';
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'

export default Vue.extend({
    name: 'EventForm',
    components: { TiptapVuetify },
    props: ['formTitle','formAction','dataEventProp'],
    data: () => ({
      siteFormDialog: false,
      msgError: '',
      msgSuccess: '',
      buttonTitle: 'Créer',
      buttonIcon: 'mdi-pencil-plus-outline',
      eventData: {
        name:'',
        date:'',
        subscriptionOpen:true,
        siteId:0,
        eventCategoryId:0,
        paymentEnabled:false
      },
      guestCategories: [] as any [],
      guestCategoriesMemory: [] as any [],
      guestCategoriesItems: [] as any[],
      sitesList: [] as any[],
      eventCategoryList: [] as any[],
      minDate: new Date().toISOString().substr(0, 10),
      calendar: false,
      extensions: [
          History,
          Blockquote,
          Link,
          Underline,
          Strike,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3]
            }
          }],
          Bold,
          Link,
          Code,
          HorizontalRule,
          Paragraph,
          HardBreak
        ]
    }),
    mounted() {
      this.getSitesList();
      this.getEventCategoryList();
      this.initProps();
      this.getGuestCategories();
      this.getChosenGuestCategoryForEvent();      
    },
    methods: {
      changeEventName(){
        const cat = this.eventCategoryList.find(category => category.id==this.eventData.eventCategoryId);
        const date = this.eventData.date!='' ? new Date(this.eventData.date) : undefined;
        this.eventData.name = ((this.eventData.eventCategoryId!=0 && cat && cat.name) ? cat.name : 'Evenement')
        + ' du '+ ((date)?date.toLocaleDateString('fr-FR',{ year: 'numeric', month: 'long', day: 'numeric' }):'');
      },
      initProps() {
        if (this.dataEventProp){
          this.buttonTitle = 'Modifier';
          this.buttonIcon = 'mdi-file-document-edit-outline';
          this.eventData = this.dataEventProp;
        }
      },
      handleClick() {
        this.$emit('click');
      },
      close(reset: boolean) {
        this.msgError = '';
        this.msgSuccess = '';
        if (reset)
          this.resetData();
        this.siteFormDialog = false;
        this.handleClick();
      },
      resetData(){
        this.eventData = {
          name:'',
          date:'',
          subscriptionOpen:true,
          siteId:0,
          eventCategoryId:0,
          paymentEnabled:false
        };
        this.msgError = '';
        this.msgSuccess = '';
        this.guestCategories = [];
      },
      getChosenGuestCategoryForEvent(){
        if (this.eventData.id){
          getGuestCategoriesForEvent(this.eventData.id).then(res=>{
              if (res.data){
                this.guestCategories = res.data;
                this.guestCategoriesMemory = res.data;
              }else if (res.error){
                this.msgError = 'Veuillez choisir un site.'
              }
          });
        }
      },
      getGuestCategories(){
        getGuestCategoriesForEventCategory(this.eventData.eventCategoryId).then(res=>{
            if (res.data){
              this.guestCategoriesItems = res.data;
            }else if (res.error){
              this.msgError = 'Veuillez choisir un site.'
            }
        });
      },
      save(){
        if (this.dataEventProp){
          this.updateSite();
        }else{
          this.createSite();
        }
      },
      createSite(){
        this.msgSuccess = '';
        this.msgError= '';
        postEvent(this.eventData).then(res=>{
            if (res.data){
              const eventGuestRelationData = [];
              for (const guestCategory of this.guestCategories ){
                eventGuestRelationData.push({
                  eventId: res.data.id,
                  guestCategoryId: guestCategory.id
                });
              }
              postEventGuestCategoryRelations(eventGuestRelationData).then(resGR=>{
                if (resGR.data){
                  this.msgSuccess = 'Relation créé.'
                  this.close(true);
                }else if (resGR.error){
                  this.msgError = 'Erreur dans la création de la relation Event - Guest Category.'
                }
              });
              
            }else if (res.error){
              this.msgError = 'Erreur dans la création du site. Veuillez remplir tous les champs.'
            }
        });
      },
      updateSite(){
        this.msgSuccess = '';
        this.msgError= '';
        patchEvent(this.eventData).then(res=>{
            if (res.data){
              const eventGuestRelationDataNew = [];
              const eventGuestRelationDataDelete = [];
              for (const guestCategoryChosen of this.guestCategories){
                let isNew = true;
                for ( const guestCategoryMemory of this.guestCategoriesMemory ){
                  if (guestCategoryChosen.id == guestCategoryMemory.id) isNew= false;
                }
                if (isNew){
                  eventGuestRelationDataNew.push({
                    eventId: this.eventData.id,
                    guestCategoryId: guestCategoryChosen.id
                  });
                }
              }
              for (const guestCategoryMemory of this.guestCategoriesMemory){
                let toDelete = true;
                for ( const guestCategoryChosen of this.guestCategories ){
                  if (guestCategoryChosen.id == guestCategoryMemory.id) toDelete= false;
                }
                if (toDelete){
                  eventGuestRelationDataDelete.push({
                    eventId: this.eventData.id,
                    guestCategoryId: guestCategoryMemory.id
                  });
                }
              }
              this.guestCategoryMemory=this.guestCategories;
              postEventGuestCategoryRelations(eventGuestRelationDataNew).then(resGR=>{
                if (resGR.data){
                  this.msgSuccess = 'Relation créé.'
                }else if (resGR.error){
                  this.msgError = 'Erreur dans la création de la relation Event - Guest Category.'
                }
              });
              deleteEventGuestCategoryRelations(eventGuestRelationDataDelete).then(resGR=>{
                if (resGR.data){
                  this.msgSuccess = 'Relation supprimée.'
                }else if (resGR.error){
                  this.msgError = 'Erreur dans la création de la relation Event - Guest Category.'
                }
              });
              this.close(false);
            }else if (res.error){
                this.msgError = 'Erreur dans la modification de l\'événement. Veuillez remplir tous les champs. '
            }
        });
      },
      getSitesList(){
        getSites().then(res=>{
          if (res.data){
          this.sitesList = res.data;
          }else if (res.error){
          this.msgError = 'Erreur dans la recupération des données des sites.'
          }
        });
      },
      getEventCategoryList(){
        getEventCategories().then(res=>{
            if (res.data){
            this.eventCategoryList = res.data;
            }else if (res.error){
            this.msgError = 'Erreur dans la recupération des données des catégories.'
            }
        });
      }
    }
  })
